import React, { forwardRef } from "react"
import { Box, SxProps } from "@mui/material"

interface PaperProps {
    children: React.ReactNode;
    sx?: SxProps;
}

export const Paper = forwardRef<HTMLDivElement, PaperProps>(({ children, sx }, ref) => {
    return <Box ref={ref} sx={{ 
        p: 0, 
        borderRadius: 2, 
        border: 1, 
        borderColor: 'divider', 
        backgroundColor: 'background.paper',
        ...sx 
    }}>
        {children}
    </Box>;
});

